module.exports = __webpack_public_path__ + "static/media/MP3.dbea251c.png";